import WebUtils from "../../services/WebUtils";
import { IAdditionalProductInfo } from "../models/product/IAdditionalProductInfo";
import { IProductProvider, ILpSeriesInfo } from "./IProductProvider";

export interface IAdditionalProductsWebProviderParams {
	onProductInfosArrived?: (data: any) => void;
	getProductInfosFallback?: () => Promise<any>;

	productInfoEndpoint?: string;
	additionalProductInfoEndpoint?: string;
	ownershipEndpoint?: string;

	sendCredentials?: boolean;

	separateProductAndSeries?: boolean

	isSubscriber?: boolean
}

export class ProductProviderWeb implements IProductProvider{
	public webUtils: WebUtils;
	private additionalParams: IAdditionalProductsWebProviderParams

	constructor(webUtils: WebUtils, additionalParams?: IAdditionalProductsWebProviderParams){
		this.webUtils = webUtils;
		this.additionalParams = additionalParams;
	}

    public getLpSeriesInfo(): Promise<ILpSeriesInfo[]> {
        return new Promise<ILpSeriesInfo[]>((resolve, reject) => {
			setTimeout(() => {
				this.webUtils.ajax(
					(this.additionalParams != null && this.additionalParams.ownershipEndpoint) || this.webUtils.getAbsoluteBackendUrl("/search/lpSeriesInfo"),
					data => resolve(data),
					e => reject(e),
					{},
				);
			}, 200)
        });
    }

	public getOwnershipInfo(): Promise<{[key: string]: boolean}> {
		return new Promise((resolve, reject) => {
			this.webUtils.ajax(
				(this.additionalParams != null && this.additionalParams.ownershipEndpoint) || this.webUtils.getAbsoluteBackendUrl("/search/ownership"),
				data => resolve(data),
				e => reject(e),
				{},
				false,
				true
			)
		})
	}

	public getRawProductInfos(): Promise<[]> {
		return new Promise((resolve, reject) => {
			this.webUtils.ajax(
				(this.additionalParams != null && this.additionalParams.productInfoEndpoint) || this.webUtils.getAbsoluteBackendUrl("/api/search/productsAutocompleteInfo"),
				(data) => {
					if (!data || !data.length) {
						if (!this.additionalParams || !this.additionalParams.separateProductAndSeries || !(this.additionalParams.separateProductAndSeries && (data?.liveProjects?.length || data?.liveProjectSeries?.length))) {
							resolve([])
							return
						}
					}
					if (data?.liveProjectSeries?.length > 0) {
						data.liveProjectSeries = data.liveProjectSeries.map(serie => {
							serie.tags = [];
							if(!serie.durationInWeeks){
								serie?.liveProjects?.forEach((it) => {
									serie.tags = [...serie.tags, ...it.tags]
									serie.durationInWeeks += it.durationInWeeks;
								})
							}
							if(!serie.hoursPerWeek){
								serie.hoursPerWeek = serie?.liveProjects?.[0]?.hoursPerWeek;
							}
							if(!serie.difficulty){
								serie.difficulty = serie?.liveProjects?.[0]?.difficulty;
							}
							if(serie.unitAmountDiscounted){
								const price: number = serie.price - (serie.unitAmountDiscounted ? serie.unitAmountDiscounted : 0);
                            	const priceWithoutDiscount: number = serie.price;
								serie.price = price;
								serie.priceWithoutDiscount = priceWithoutDiscount;
							}
							
							serie.tags = serie.tags.filter((item, i, ar) => ar.indexOf(item) === i)
							
							return serie
						})
					}
					resolve(data)
				},
				(e) => {
					reject(e)
				},
				{
					new: true,
				},
				false,
				this.additionalParams && this.additionalParams.sendCredentials ? true : false
			)
		})
	}

    public getAdditionalProductInformation(productIds: number[]): Promise<IAdditionalProductInfo[]> {
		return new Promise<IAdditionalProductInfo[]>((resolve, reject) => {
            this.webUtils.post(
                (this.additionalParams != null && this.additionalParams.additionalProductInfoEndpoint) || this.webUtils.getAbsoluteBackendUrl("/search/additionalProductInformation"),
                data => resolve(data),
                e => reject(e),
                {
                    productIds: productIds.join(",")
                }
            );
        });
    }
}